import { z } from 'zod';

import { BcryptHash } from './primitives.js';

/**
 * Admin escape-hatch settings. Always present in config; tier-gated at runtime.
 *
 * Cross-field rule: `exitPinHash` must be present when `exitGestureEnabled`
 * is true. PINs are bcrypt-hashed by the Builder client-side; plaintext
 * PINs never enter config.
 */
export const AdminAccess = z
  .object({
    exitGestureEnabled: z.boolean(),
    exitPinHash: BcryptHash.optional(),
    diagnosticOverlayEnabled: z.boolean(),
    auditLogEnabled: z.boolean(),
  })
  .refine((a) => !a.exitGestureEnabled || a.exitPinHash !== undefined, {
    message: 'exitPinHash is required when exitGestureEnabled is true',
    path: ['exitPinHash'],
  });
export type AdminAccess = z.infer<typeof AdminAccess>;
